import React, { useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { Chip } from "primereact/chip";
import { Button } from "primereact/button";
import { CustomButton } from "../CustomButton";

const TimePicker = ({
  value = [], // ["10:30", "12:15"]
  onChange,
  minuteInterval = 1,
  multiple = false,
  disabled = false,
}) => {
  const [hour, setHour] = useState("");
  const [minute, setMinute] = useState("");

  const hours = Array.from({ length: 24 }, (_, i) =>
    String(i).padStart(2, "0")
  ).map((h) => ({ label: h, value: h }));

  const minutes = Array.from({ length: 60 / minuteInterval }, (_, i) =>
    String(i * minuteInterval).padStart(2, "0")
  ).map((m) => ({ label: m, value: m }));

  // Add time into array
  const handleAdd = () => {
    if (!hour || !minute) return;

    const newTime = `${hour}:${minute}`;
    const updated = [...value, newTime];

    onChange?.(updated);
    setHour("");
    setMinute("");
  };

  // Remove an item from array
  const removeTime = (time) => {
    const updated = value.filter((t) => t !== time);
    onChange?.(updated);
  };

  console.log("TimePicker Rendered", value);
  return (
    <>
      <div className="my-2 mb-2">
        {multiple && value.length > 0 && (
          <div className="flex flex-wrap gap-2">
            {value.map((time) => (
              <Chip
                key={time}
                label={time}
                removable
                onRemove={() => removeTime(time)}
              />
            ))}
          </div>
        )}
      </div>
      <div className="flex flex-col gap-3">
        {/* Picker Row */}
        <div className="flex gap-4 items-center">
          <Dropdown
            value={hour}
            options={hours}
            onChange={(e) => setHour(e.value)}
            placeholder="HH"
            className="w-24"
            panelClassName="w-24"
            disabled={disabled}
          />

          <Dropdown
            value={minute}
            options={minutes}
            onChange={(e) => setMinute(e.value)}
            placeholder="MM"
            className="w-24"
            panelClassName="w-24"
            disabled={disabled}
          />

          {/* Add Button */}
          {multiple && (
            <CustomButton
              icon="pi pi-plus"
              //   className="p-button-rounded p-button-sm"
              onClick={handleAdd}
              disabled={disabled}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default TimePicker;
